import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  userAccess,
  employeeAccess,
  allWorksAccess,
  reviewAccess,
  declineAccess,
  workAccess,
  efficiencyAccess,
  publicationsAccess,
  dictionariesAccess,
  employeeDirectoryAccess,
  oppositionAccess
} from '@/router/pageAccesses'

Vue.use(VueRouter)

class Page {
  constructor(path = null, component = null, name = null, beforeEnter = userAccess) {
    this.path = path
    this.name = name
    this.component = () => import(`@/${component}`)
    this.beforeEnter = beforeEnter
  }
}

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/works' },
    new Page('/login', 'pages/Auth/Login', 'login'),
    new Page('/registration/:username/:code', 'pages/Auth/Registration', 'registrationConfirm'),
    new Page('/registration', 'pages/Auth/Registration', 'registration'),
    new Page('/forget', 'pages/Auth/ForgetPassword', 'forget'),
    new Page('/forget/:username/:code', 'pages/Auth/ForgetPassword', 'forgetConfirm'),

    new Page('/employee', 'pages/Employee', 'employee', employeeAccess),

    new Page('/efficiency', 'pages/Efficiency', 'efficiency', efficiencyAccess),

    {
      ...new Page('/journal-editorail-boards', 'pages/JournalEditorialBoards/Index', 'journal-editorial-boards'),
      redirect: { name: 'journals' },
      children: [
        new Page('/journal-editorail-boards/journals', 'pages/JournalEditorialBoards/Journals', 'journals'),
        new Page('/journal-editorail-boards/journals/:mode/:id', 'pages/JournalEditorialBoards/JournalPage', 'journal')
      ]
    },

    {
      ...new Page('/publications', 'pages/Publications/index', 'publications'),
      redirect: { name: 'publicationsParent' },
      children: [
        new Page(
          '/publications/publicationsParent',
          'pages/Publications/PublicationsParent',
          'publicationsParent',
          publicationsAccess
        ),
        new Page('/publications/protected', 'pages/Publications/Protected', 'protected', publicationsAccess),
        new Page('/publications/points', 'pages/Publications/Points', 'points', publicationsAccess),
        new Page('/publications/opposition', 'pages/Publications/Opposition', 'opposition', oppositionAccess)
      ]
    },

    {
      ...new Page('/works', 'pages/Works/index', 'works'),
      redirect: { path: '/works/commonWork' },
      children: [
        {
          ...new Page('/works/commonWork', 'pages/Works/CommonWork/index', 'commonWork'),
          redirect: { path: '/works/commonWork/allWorks' },
          children: [
            new Page('/works/commonWork/allWorks', 'pages/Works/CommonWork/AllWorks', 'allWorksPage', allWorksAccess),
            new Page('/works/commonWork/review', 'pages/Works/CommonWork/Review', 'reviewPage', reviewAccess),
            new Page('/works/commonWork/decline', 'pages/Works/CommonWork/Decline', 'declinePage', declineAccess)
          ]
        },
        new Page('/works/monography/:mode/:id', 'pages/Works/MonographyPage', 'monographyPage', workAccess),
        new Page('/works/prePrint/:mode/:id', 'pages/Works/PrePrintPage', 'prePrintPage', workAccess),
        new Page('/works/grant/:mode/:id', 'pages/Works/GrantPage', 'grantPage', workAccess),
        new Page('/works/studentGuide/:mode/:id', 'pages/Works/StudentGuidePage', 'studentGuidePage', workAccess),
        new Page('/works/dissertation/:mode/:id', 'pages/Works/DissertationPage', 'dissertationPage', workAccess),
        new Page('/works/performance/:mode/:id', 'pages/Works/PerformancePage', 'performancePage', workAccess),
        /*        new Page('/works/peerReviewedPublication/:mode/:id', 'pages/Works/PeerReviewedPublicationPage',
                  'peerReviewedPublicationPage', workAccess),*/
        new Page('/works/incalculation/:mode/:id', 'pages/Works/IncalculationPage', 'incalculationPage', workAccess),
        /*        new Page('/works/foreignCitation/:mode/:id', 'pages/Works/ForeignCitationPage', 'foreignCitationPage',
                  workAccess),*/
        new Page('/works/contest/:mode/:id', 'pages/Works/ContestPage', 'contestPage', workAccess),
        new Page(
          '/works/educationalPublication/:mode/:id',
          'pages/Works/EducationalPublicationPage',
          'educationalPublicationPage',
          workAccess
        ),
        new Page(
          '/works/nirAccomplishment/:mode/:id',
          'pages/Works/NirAccomplishmentPage',
          'nirAccomplishmentPage',
          workAccess
        ),
        new Page(
          '/works/publicOrganizationParticipation/:mode/:id',
          'pages/Works/PublicOrganizationParticipationPage',
          'publicOrganizationParticipationPage',
          workAccess
        ),
        new Page('/works/publication/:mode/:id', 'pages/Works/PublicationPage', 'publicationPage', workAccess),
        new Page('/works/overseasEvent/:mode/:id', 'pages/Works/OverseasEventPage', 'overseasEventPage', workAccess),
        new Page(
          '/works/cooperationInformation/:mode/:id',
          'pages/Works/CooperationInformationPage',
          'CooperationInformationPage',
          workAccess
        ),
        new Page('/works/stateAward/:mode/:id', 'pages/Works/StateAwardPage', 'StateAwardPage', workAccess),
        new Page(
          '/works/nirCompensationAgreement/:mode/:id',
          'pages/Works/NirCompensationAgreementsPage',
          'NirCompensationAgreementsPage',
          workAccess
        ),
        new Page(
          '/works/winningScientificCompetition/:mode/:id',
          'pages/Works/WinningScientificCompetition',
          'WinningScientificCompetitionPage',
          workAccess
        ),
        new Page(
          '/works/scientificPracticalEvent/:mode/:id',
          'pages/Works/ScientificPracticalEvent',
          'ScientificPracticalEventPage',
          workAccess
        )
      ]
    },

    {
      ...new Page('/directories', 'pages/directories/index', 'directories'),
      redirect: { name: 'publishingHouseParent' },
      children: [
        new Page(
          '/directories/publishingHouse',
          'pages/directories/PublishingHouseParent',
          'publishingHouseParent',
          dictionariesAccess
        ),
        new Page('/directories/magazine', 'pages/directories/MagazineParent', 'magazineParent', dictionariesAccess),
        new Page(
          '/directories/speciality',
          'pages/directories/SpecialityParent',
          'specialityParent',
          dictionariesAccess
        ),
        new Page(
          '/directories/protectionPlace',
          'pages/directories/ProtectionPlaceParent',
          'protectionPlaceParent',
          dictionariesAccess
        ),
        new Page(
          '/directories/councilMember',
          'pages/directories/CouncilMemberParent',
          'councilMemberParent',
          dictionariesAccess
        ),
        new Page('/directories/period', 'pages/directories/PeriodParent', 'PeriodParent', dictionariesAccess)
      ]
    },
    new Page('/employee-directory', 'pages/directories/EmployeeParent', 'employeeParent', employeeDirectoryAccess),

    //new Page('/reports', 'pages/Auth/ReportParent', 'reportParents'),
    //new Page('/report', 'pages/ReportParent', 'reportParent'),
    //new Page('/authorWork', 'pages/AuthorWorkParent', 'authorWorkParent'),
    //new Page('/bibliographyWork', 'pages/BibliographyWorkParent', 'bibliographyWorkParent'),
    //new Page('/efficiencyMetric', 'pages/EfficiencyMetricParent', 'efficiencyMetricParent'),
    //new Page('/opposition', 'pages/OppositionParent', 'oppositionParent'),

    new Page('/notFound', 'pages/NotFound', 'notFound'),
    { path: '*', redirect: '/notFound' }
  ]
})
